import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { Features } from '../../models/features';
import { IFeaturesService } from '../../services/services';
import { Router } from '@angular/router';

interface MenuRoute {
  path?: string;
  name?: string;
  icon?: string;
  showSub?: boolean;
  subroutes?: MenuRoute[];
}

@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.css'],
    standalone: false
})
export class MenuComponent implements OnInit {
  isCollapsed = false;
  public companyAdministrationFeatureEnabled = false;
  public userProfileUiEnabled = false;
  public featuresReady = false;

  @Output() collapse = new EventEmitter<boolean>();
  @Input() routes: MenuRoute[] = [];

  constructor(
    private router: Router,
    private _featuresService: IFeaturesService,
    ) { }

  ngOnInit() {
    this.getFeatures();
  }

  getFeatures() {
    this._featuresService.getEnabledFeatures().subscribe(
      result => {
        if (result === null) { return; }
        this.companyAdministrationFeatureEnabled = result.indexOf(Features.CompanyAdministration) >= 0;
        this.userProfileUiEnabled = result.indexOf(Features.UserProfileUi) >= 0;
        this.featuresReady = true;
      },
      error => {
        this.companyAdministrationFeatureEnabled = false;
      },
    );
  }

  onCollapsedClick(): void {
    this.isCollapsed = !this.isCollapsed;
    this.collapse.emit(this.isCollapsed);
  }

  onRouteClick(route: MenuRoute): void {
    if ((route.subroutes?.length ?? 0) > 0) {
      route.showSub = !route.showSub;
      return;
    }

    const path = (route.path ?? '').trim();
    if (!path) {
      return;
    }

    const normalizedPath = path.startsWith('/') ? path : `/${path}`;
    void this.router.navigate([normalizedPath]);
  }


}
